import { atom } from "jotai";

/**
 * Filter atoms for Worklist
 *
 * These atoms manage the filter state that was previously prop-drilled
 * through Worklist -> StudyRow. Now any component can access/update
 * filter state directly.
 */

// Device filter (model type) - filters studies by device_id
export const selectedDeviceIdAtom = atom<string | null>(null);

// Finding filter (organ/condition) - filters studies by detected findings
export const selectedFindingsAtom = atom<string[]>([]);

// Filter mode - 'any' matches studies with at least one finding, 'all' requires all
export const findingFilterModeAtom = atom<"any" | "all">("any");

// Preview panel state - which study is being previewed
export const previewStudyIdAtom = atom<string | null>(null);

// Global search query - searches across all findings in all studies
export const searchQueryAtom = atom<string>("");

// Sort mode for case list
export type SortMode =
  | "default"
  | "findings_desc"
  | "findings_asc"
  | "alphabetical"
  | "severity"
  | "flagged";
export const sortModeAtom = atom<SortMode>("default");
